import { render, staticRenderFns } from "./eventRemoteSettingComponent.vue?vue&type=template&id=342007c0&scoped=true&"
import script from "./eventRemoteSettingComponent.vue?vue&type=script&lang=ts&"
export * from "./eventRemoteSettingComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342007c0",
  null
  
)

export default component.exports